import { OverlayRef } from '@angular/cdk/overlay';
import { IBbitAlgoliaFilterItem } from '../filter-bar.component';

export class FilterDropdownOverlayRef {
  public constructor(
    private _overlayRef: OverlayRef,
    public item: IBbitAlgoliaFilterItem,
  ) {}

  public close(): void {
    this._overlayRef.dispose();
  }
}
